import { render, staticRenderFns } from "./AdminFilters.vue?vue&type=template&id=97201bc4"
import script from "./AdminFilters.vue?vue&type=script&lang=js"
export * from "./AdminFilters.vue?vue&type=script&lang=js"
import style0 from "./AdminFilters.vue?vue&type=style&index=0&id=97201bc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports